import Cookies from 'js-cookie'
import DefaultConfig from '@/settings'

const tokenKey = DefaultConfig.tokenKey

// 获取Token
export function getToken() {
  return Cookies.get(tokenKey)
}

// 设置Token
export function setToken(token, rememberMe) {
  if (rememberMe) {
    return Cookies.set(tokenKey, token, { expires: DefaultConfig.tokenCookieExpires })
  } else return Cookies.set(tokenKey, token)
}

// 删除Token
export function removeToken() {
  return Cookies.remove(tokenKey)
}
